angular
    .module('harriApp')
    .controller('positionTagsFeedbackModal', [
        '$scope', '$state', 'modalData',
        function ($scope, $state, modalData) {
            $scope.modalData = modalData;
            $scope.thumbsState = null;

            $scope.toggleThumbs = (state) => {
                $scope.thumbsState = ($scope.thumbsState === state) ? null : state;
            };

            $scope.submit = async () => {
                if ($scope.thumbsState) {
                    const {brandId, tagId, candidateId} = $scope.modalData;
                    try {
                        await TalentPoolAPI2.updateTagPositionFeedback(
                            brandId,
                            tagId,
                            candidateId,
                            $scope.thumbsState,
                            $scope.note
                        );
                        HNotifications.show({
                            title: $filter("translate")("Success"),
                            desc: $filter("translate")("Submit successfully") + "!",
                            icon: "fa-check-circle",
                            type: "success"
                        });
                        $scope.close();
                    } catch (err) {
                        HNotifications.show({
                            title: $filter("translate")("Error"),
                            desc: $filter("translate")("Something went wrong!"),
                            icon: "fa-times-circle",
                            type: "danger"
                        });
                    }
                }
            };

            $scope.close = () => {
                $scope.$hide();
            };
        }]);
